import React from "react"
import ReactNative from "react-native"
import Device from "app/lib/Device"
import FS from "app/components/FS"

import { colors } from "app/lib/styles"

const { View, StyleSheet, InteractionManager } = ReactNative

export default class ChallengeStat extends React.Component {
  static defaultProps = {
    tintColor: colors.challengeBlue,
    isPercent: false,
  }

  render() {
    var value = this.props.value
    if (this.props.isPercent) {
      value = `${Math.round(value)}`
    }

    return (
      <View style={styles.statWrap}>
        <FS.Text style={styles.statTop} numberOfLines={3} allowFontScaling={false}>
          {this.props.topLabel}
        </FS.Text>
        <View style={styles.statValueWrap}>
          <FS.Text
            style={[styles.statValue, { color: this.props.tintColor }]}
            numberOfLines={1}
            allowFontScaling={false}
          >
            {value}
          </FS.Text>
          {this.props.isPercent ? (
            <View style={styles.statPercentSignWrap}>
              <FS.Text
                style={[styles.statPercentSign, { color: this.props.tintColor }]}
                allowFontScaling={false}
              >
                %
              </FS.Text>
            </View>
          ) : null}
        </View>
        <FS.Text style={styles.statBottom} numberOfLines={1} allowFontScaling={false}>
          {this.props.bottomLabel}
        </FS.Text>
      </View>
    )
  }
}

var styles = StyleSheet.create({
  statWrap: {
    flex: 1,
  },
  statTop: {
    textAlign: "center",
    color: colors.gray,
    fontSize: 12,
    fontWeight: "800",
    letterSpacing: 1,
  },
  statBottom: {
    textAlign: "center",
    color: colors.gray,
    fontSize: 12,
    fontWeight: "800",
    letterSpacing: 1,
  },
  statValueWrap: {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 0,
    marginVertical: 0,
  },
  statValue: {
    textAlign: "center",
    color: colors.challengeBlue,
    fontSize: 55,
    fontWeight: "300",
    letterSpacing: -1.3,
  },
  statPercentSignWrap: {
    position: "absolute",
    top: 11,
    right: -13,
    backgroundColor: "transparent",
  },
  statPercentSign: {
    fontSize: 16,
    fontWeight: "600",
    color: colors.challengeBlue,
    letterSpacing: -0.4,
  },
})
